module.exports = __webpack_public_path__ + "img/coins-payout.5fe0ea4.svg";